import { FunctionComponent } from 'react';

const HTMLContent: FunctionComponent<{ html: string[] }> = ({ html }) => {
  return (
    <>
      <div className=" mx-5 font">
        {html?.map((html: string, index) => (
          <div dangerouslySetInnerHTML={{ __html: html }} key={index} />
        ))}
      </div>
    </>
  );
};

export default HTMLContent;
